import styled from '@emotion/styled';
import { FixedTag, LoopTag } from './Tag';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';
import {
  yearText,
  dayText,
  weekText,
  foreverText,
} from '@knowledge/knowledges/general/KnowledgeListForm/ConditionRenderer';

type TimeListItemProps = {
  dataSource: Knowledge.PresetTime;
};

function TimeListItem(props: TimeListItemProps) {
  const { dataSource } = props;
  const { t } = useTranslate();

  const { name, dtScope } = dataSource;

  const class1 =
    'text-[12px] text-[var(--fett-text-tertiary)] h-[18px] basis-[100%] flex-shrink-0 truncate';

  const ranges = useMemo(() => {
    if (dtScope.filterCode === 'DT_SPECIFIED') {
      return dtScope.specifiedDtRange?.map((each) => {
        const { startAt, endAt } = each;
        return (
          <div className={class1}>
            {startAt}
            &nbsp;-&nbsp;
            {foreverText(t, endAt)}
          </div>
        );
      });
    }
    if (dtScope.filterCode === 'DT_REPEAT') {
      if (dtScope.repeatType === 'YEAR') {
        return (
          <div className={class1} title={yearText(t, dtScope)}>
            {yearText(t, dtScope)}
          </div>
        );
      }
      if (dtScope.repeatType === 'WEEK') {
        return (
          <div className={class1} title={weekText(t, dtScope)}>
            {weekText(t, dtScope)}
          </div>
        );
      }
      if (dtScope.repeatType === 'DAY') {
        return (
          <div className={class1} title={dayText(t, dtScope)}>
            {dayText(t, dtScope)}
          </div>
        );
      }
    }
    return null;
  }, [t, dtScope, class1]);

  return (
    <ListItem>
      <Header>
        <div className="text-[12px] text-[var(--fett-text-secondary)]">{name}</div>
        {dtScope.filterCode === 'DT_REPEAT' ? (
          <LoopTag>{t('knowledge.循环')}</LoopTag>
        ) : (
          <FixedTag>{t('knowledge.固定')}</FixedTag>
        )}
      </Header>
      <div className="mt-[4px]">{ranges}</div>
    </ListItem>
  );
}

const ListItem = styled.div`
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid var(--fett-border-strong);
  background: var(--fett-bg-panel);
  margin-bottom: 8px;
`;

const Header = styled.div`
  display: flex;
  height: 18px;
  align-items: center;
  justify-content: space-between;
`;

export default TimeListItem;
